import React from 'react'
import { track } from "../../../../analytics";
import './VpsSliderCard.scss'

/*
  Карточка тарифа. Шапки с картинкой больше нет: она была одна на все
  карточки и ничего не сообщала. Строка характеристик без значения
  (у Bitrix «Двухъядерный процессор») занимает всю ширину — иначе
  справа оставалась пустая колонка.
*/
const VpsSliderCard = ({ vpsSliderCards, colorButton }) => {
  // В данных цена одной строкой «49 TJS/мес» — делим на сумму и период,
  // чтобы период набрать мельче. Данные при этом не трогаем.
  const [amount, per] = String(vpsSliderCards.prefPrice || '').split('/');

  return (
    <div className="vpsSliderCard_block">
      <h3 className="vpsSliderCard_name">{vpsSliderCards.name}</h3>
      <p className="vpsSliderCard_desc">{vpsSliderCards.title}</p>

      <div className="vpsSliderCard_params">
        {vpsSliderCards.param?.map((e) => (
          <div
            className={'vpsSliderCard_param' + (e.name ? '' : ' vpsSliderCard_param--single')}
            key={e.id}
          >
            <span className="vpsSliderCard_label">{e.key}</span>
            {e.name ? <span className="vpsSliderCard_value">{e.name}</span> : null}
          </div>
        ))}
      </div>

      <p className="vpsSliderCard_price">
        {amount.trim()}
        {per ? <span className="vpsSliderCard_per">/{per.trim()}</span> : null}
      </p>

      <button
        type="button"
        className={'vpsSliderCard_btn' + (colorButton ? ' vpsSliderCard_btn--accent' : '')}
        onClick={() => track('cta_click', {
          place: colorButton ? 'bitrix' : 'vps',
          label: 'Подключить',
          product: String(vpsSliderCards?.name || ''),
        })}
      >
        Подключить
      </button>
    </div>
  )
}

export default VpsSliderCard
